var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('RouterLink',{class:[_vm.isActive ? 'current' : ''],attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }